<template>
  <Form class="form-window" @submit="submit">
    <AddProjectFormInput
      id="old-password-input"
      v-model="oldPass"
      type="password"
      :required="true"
      :label-text="$t('Current password')"
    />
    <AddProjectFormInput
      id="new-password-input"
      v-model="newPass"
      type="password"
      :required="true"
      :label-text="$t('New password')"
    />
    <AddProjectFormInput
      id="new-password-repeat-input"
      v-model="confPass"
      type="password"
      :required="true"
      :label-text="$t('Repeat new password')"
    />
    <div class="user-form-custom-footer">
      <Button color="primary" @click="submit">
        <Spinner v-if="isLoading" size="20" />
        <span v-else>
          {{ $t('Save changes') }}
        </span>
      </Button>
      <SuccessAlert v-if="success" class="mx-4" />
      <ErrorAlert v-else-if="error" :error="error" class="mx-4" />
    </div>
  </Form>
</template>

<script>
  import AddProjectFormInput from '@/components/ui/FormInput';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/formatting/parse-error';
  import Form from '@/components/common/Form';
  import Spinner from 'vue-simple-spinner';
  import Button from '@/components/ui/Button';
  import SuccessAlert from '@/components/common/SuccessAlert';
  import ErrorAlert from '@/components/common/ErrorAlert';

  export default {
    name: 'UserSettingsAccountForm',
    components: {
      ErrorAlert,
      SuccessAlert,
      Button,
      Form,
      AddProjectFormInput,
      Spinner,
    },
    data() {
      return {
        oldPass: '',
        newPass: '',
        confPass: '',
        success: false,
        error: null,
        isLoading: false,
      };
    },
    methods: {
      validate() {
        this.success = false;
        this.error = null;
        if (!this.oldPass || !this.newPass || !this.confPass) {
          this.error = 'Some fields are still empty';
          return false;
        } else if (this.newPass.length < 6) {
          this.error = 'New password is too short. At least 6 characters are required';
          return false;
        } else if (this.newPass !== this.confPass) {
          this.error = 'Password is not properly repeated';
          return false;
        }
        return true;
      },
      async submit() {
        this.isLoading = true;
        if (!this.validate()) {
          this.isLoading = false;
          return;
        }
        try {
          await factory('profile').postInPath('change_password', {
            old_password: this.oldPass,
            new_password: this.newPass,
          });
          this.success = true;
        } catch (e) {
          const err = parseError(e);
          this.error(err);
        }
        this.isLoading = false;
      },
    },
  };
</script>
